import { render, staticRenderFns } from "./FraccionesList.vue?vue&type=template&id=4e55a134&"
import script from "./FraccionesList.vue?vue&type=script&lang=js&"
export * from "./FraccionesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports